// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/af3156f1-1793686605864/" + ({"196":"af3156f1-1793686605864/HomeError","299":"b7bfefd8"}[chunkId] || chunkId) + ".js";
};